import { Cache } from "memory-cache";
import { CorporationRolesEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationRolesEntity(character_id: number): Promise<CorporationRolesEntity | null> {
  let entity: any = await cache.get(character_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationRoleEntity(roles: CorporationRolesEntity, char_id: number) {
  cache.put(char_id, roles, 60 * 60 * 1000 /* 1 hour */);
}
